export const machineCsvConstants = {
  GET_CSV_CATALOG_REQUEST: 'MACHINES_CSV_GET_CATALOG_REQUEST',
  GET_CSV_CATALOG_SUCCESS: 'MACHINES_CSV_GET_CATALOG_SUCCESS',
  GET_CSV_CATALOG_FAILURE: 'MACHINES_CSV_GET_CATALOG_FAILURE',

  EXPORT_CSV_REQUEST: 'MACHINES_CSV_EXPORT_REQUEST',
  EXPORT_CSV_SUCCESS: 'MACHINES_CSV_EXPORT_SUCCESS',
  EXPORT_CSV_FAILURE: 'MACHINES_CSV_EXPORT_FAILURE',

  PREVIEW_IMPORT_REQUEST: 'MACHINES_CSV_PREVIEW_IMPORT_REQUEST',
  PREVIEW_IMPORT_SUCCESS: 'MACHINES_CSV_PREVIEW_IMPORT_SUCCESS',
  PREVIEW_IMPORT_FAILURE: 'MACHINES_CSV_PREVIEW_IMPORT_FAILURE',

  APPLY_IMPORT_REQUEST: 'MACHINES_CSV_APPLY_IMPORT_REQUEST',
  APPLY_IMPORT_SUCCESS: 'MACHINES_CSV_APPLY_IMPORT_SUCCESS',
  APPLY_IMPORT_FAILURE: 'MACHINES_CSV_APPLY_IMPORT_FAILURE',

  RESET_IMPORT: 'MACHINES_CSV_RESET_IMPORT'
};

// The column every exported file starts with; an import matches rows on it.
export const KEY_COLUMN = 'id';

export const EXPORT_SCOPE = {
  VIEW: 'view',
  ALL: 'all'
};

export const IMPORT_STEPS = ['upload', 'problems', 'preview', 'done'];

export const COLUMN_GROUPS = {
  IDENTITY: 'identity',
  EDITABLE: 'editable',
  READ_ONLY: 'read_only'
};

// The value the backend sends for each criticality, and its existing label key.
export const CRITICALITY_LABEL_KEYS = {
  1: 'veryHigh',
  2: 'high',
  3: 'medium',
  4: 'low',
  5: 'veryLow'
};

export const EXPORT_COLUMNS_STORAGE_KEY = 'assets.csvExportColumns';

// These calls can outlast the app's default 60 s: a whole-site export, the
// check of a 5000 row file, and above all the apply, which must not be cut
// short while the server may still commit.
export const CSV_TIMEOUT_MS = {
  EXPORT: 5 * 60 * 1000,
  PREVIEW: 3 * 60 * 1000,
  APPLY: 5 * 60 * 1000
};

// Rendering more table rows than this makes a dialog sluggish.
export const MAX_ROWS_SHOWN = 1000;

// Search params the page always carries for some roles; they are not a filter
// the user applied, and the plain asset list ignores them.
export const VIEW_IGNORED_PARAMS = ['attention_criteria', 'include_snoozed'];

// The filter value that shows only changes that look like auto-formatting.
export const REFORMATTED_FILTER = '__reformatted';

export const IMPORT_STEP_LABELS = {
  upload: 'Upload',
  problems: 'Check',
  preview: 'Preview',
  done: 'Done'
};
